import { c as _c } from "react/compiler-runtime";
import { getOrgArtifactsByArtifactId } from '@onefootprint/fetch-dashboard';
import { useQuery } from '@tanstack/react-query';

// `FileReader.readAsDataURL` returns "data:<mime>;base64,<payload>"; strip the prefix
// to match the base64 shape the rest of the feature already passes around.
const blobToBase64 = (blob: Blob): Promise<string> => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onerror = () => reject(reader.error ?? new Error('Failed to read artifact bytes'));
  reader.onloadend = () => {
    const result = reader.result;
    if (typeof result !== 'string') {
      reject(new Error('Unexpected FileReader result'));
      return;
    }
    resolve(result.split(',')[1] ?? '');
  };
  reader.readAsDataURL(blob);
});

// Custom key — the SDK helper assumes JSON parsing, so we can't reuse it.
// Exposed so mutations can invalidate the cached bytes after a save.
export const artifactContentQueryKey = (artifactId: string) => ['artifact-content', artifactId] as const;
const useArtifactContent = artifactId => {
  const $ = _c(8);
  const t0 = artifactId ?? "";
  let t1;
  if ($[0] !== t0) {
    t1 = artifactContentQueryKey(t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !!artifactId;
  let t3;
  if ($[2] !== artifactId) {
    t3 = async () => {
      const response = await getOrgArtifactsByArtifactId({
        path: {
          artifactId: artifactId ?? ""
        },
        parseAs: "blob",
        throwOnError: true
      });
      return blobToBase64(response.data as Blob);
    };
    $[2] = artifactId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = {
      queryKey: t1,
      enabled: t2,
      queryFn: t3
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return useQuery(t4);
};
export default useArtifactContent;